module.exports = __webpack_public_path__ + "img/dashboard-package-delivery-alt.44956971.svg";